// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const LOAD_ERROR_MESSAGE = "Nepodarilo sa na\u010d\u00edta\u0165 obsah";
export const LOAD_ERROR_RETRY = "Sk\u00fas znovu";
